import React, { useEffect, useState } from 'react';
// @ts-ignore
import IntlTelInput from 'intl-tel-input/reactWithUtils';
import { Description, Input } from '@headlessui/react';
import { FormField } from '../../types/components';

export default function PhoneField({
  field,
  response,
}: { field: FormField, response: any }) {
  const [country, setCountry] = useState<string>('nl');
  const [number, setNumber] = useState<string>('');

  const fieldError = response?.errors?.[field.handle] || response?.errors?.[`${field.handle}.number`];

  useEffect(() => {
    const input = document.querySelector('.iti__tel-input');

    if (input instanceof HTMLInputElement) {
      input.classList.toggle('!border-accent', Boolean(fieldError));
    }
  }, [fieldError]);

  return (
    <div className="w-full phone-field">
      <label htmlFor={field.handle} className="mb-2">
        {field.label}
        {field.required && <span className="ml-1 text-accent">*</span>}
      </label>
      {field.countryEnabled ? (
        <>
          <IntlTelInput
            onChangeNumber={setNumber}
            onChangeCountry={setCountry}
            initOptions={{
              initialCountry: 'nl',
              separateDialCode: true,
              autoPlaceholder: 'off',
              formatOnDisplay: true,
              formatAsYouType: true,
            }}
            inputProps={{
              id: field.handle,
              placeholder: field.placeholder,
              required: field.required,
            }}
          />
          {fieldError && (
            <Description className="text-accent">{fieldError[0]}</Description>
          )}
          <input
            type="hidden"
            value={country}
            name={`fields[${field.handle}][country]`}
          />
          <input
            type="hidden"
            value={number}
            name={`fields[${field.handle}][number]`}
          />
        </>
      ) : (
        <>
          <Input
            type={field.fieldType}
            name={`fields[${field.handle}]`}
            placeholder={field.placeholder}
            required={field.required}
            className={fieldError ? '!border-accent' : ''}
          />
          {fieldError && (
            <Description className="text-accent">{fieldError[0]}</Description>
          )}
        </>
      )}
    </div>
  );
}
